/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AllocationDimensionGroupingTarget extends models.AllocationDimensionTarget {
    constructor() {
        super();
        this.setDiscriminator("AllocationDimensionGroupingTarget");
    }

    getFixupPrototypeFunction() { return AllocationDimensionGroupingTarget.fixupPrototype; }

    static newInstance(model: Partial<AllocationDimensionGroupingTarget>): AllocationDimensionGroupingTarget {
        let obj = Object.assign(new AllocationDimensionGroupingTarget(), model);
        AllocationDimensionGroupingTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AllocationDimensionGroupingTarget>): AllocationDimensionGroupingTarget {
        if (!model) return null;
        return AllocationDimensionGroupingTarget.newInstance(<AllocationDimensionGroupingTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AllocationDimensionGroupingTarget) {
        if (!obj) return;

        models.AllocationDimensionGroupingTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AllocationDimensionGroupingTarget): boolean {
        if (models.AllocationDimensionTarget.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AllocationDimensionGroupingTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    grouping_rule_id: string;

    grouping_rule_name: string;

}
